import React from "react";
import { Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";
import AvailableCoupons from './AvailableCoupons';

class ModalShow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,

    }
  }

  showModal = () => {
    this.setState({
      visible: true,
  
    });
  };
  onHandleCancel = () => {
    this.setState({ visible: false });
  }

  render() {

    return (
      <div>
        <Button type="danger" onClick={this.showModal}><i className="icon icon-ticket" /></Button>
        <Modal
          cancelText="Salir"
          title="Cupones disponibles"
          visible={this.state.visible}
          onCancel={this.onHandleCancel}
          onOk={this.onHandleCancel}
        >
          <AvailableCoupons coupon={this.props.recording.id}/>
        </Modal>
      </div>
    );
  }
}

export default ModalShow


// WEBPACK FOOTER //
// ./src/routes/main/Cupons/admin/ModalShow.js